import { createElement } from 'react';
import { node, string, bool, number, func } from 'prop-types';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import classNames from 'classnames';
import 'reakit/Tabs';
import { Tab as Tab$1 } from './styled.js';

var noop = function noop() {};

var Tab = function Tab(_ref) {
  var children = _ref.children,
      className = _ref.className,
      isActive = _ref.isActive,
      props = _objectWithoutPropertiesLoose(_ref, ["children", "className", "isActive"]);

  return createElement(Tab$1, _extends({}, props, {
    className: classNames(className, {
      active: isActive
    })
  }), children);
};

var tabPropTypes = {
  children: node.isRequired,
  className: string,
  isActive: bool,
  tab: string.isRequired,
  current: number.isRequired,
  register: func.isRequired,
  update: func.isRequired,
  unregister: func.isRequired,
  isCurrent: func.isRequired,
  show: func.isRequired,
  next: func.isRequired,
  previous: func.isRequired
};
Tab.propTypes = tabPropTypes;
var tabDefaultProps = {
  className: undefined,
  isActive: false,
  register: noop,
  update: noop,
  unregister: noop,
  isCurrent: function isCurrent() {
    return false;
  },
  show: noop,
  next: noop,
  previous: noop
};
Tab.defaultProps = tabDefaultProps; // @ts-ignore

var C = Tab;
export default C;
export { Tab, tabDefaultProps, tabPropTypes };